<template>
  <v-row :style="style">
    <v-col cols="12" class="text-center" style="padding-bottom: 700px;">
      <v-progress-circular
        :size="50"
        :width="3"
        color="amber"
        indeterminate
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'MyLoader',

  props: {
    spacing: {
      type: Number,
      default: 0
    }
  },

  computed: {
    style () {
      return {
        padding: this.spacing + 'px 0',
        width: '100%'
      }
    }
  }
}
</script>
